import { render } from "./DadminNavbar.vue?vue&type=template&id=945377a8"
import script from "./DadminNavbar.vue?vue&type=script&lang=js"
export * from "./DadminNavbar.vue?vue&type=script&lang=js"

import "./DadminNavbar.vue?vue&type=style&index=0&id=945377a8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__